export default __webpack_public_path__ + "static/media/ais_bottom_logo.36e4ce1f.webp";